import CustomAction from "./CustomAction";

function Actions(action,
    showAlert,
    variables,
    setOpenVariable,
    variableRender,
    debuggingStart,
    debuggingExpand,
    automVersionId,
    automId,
    setVariables,
    automDetail,
    setAutomDetail,
    fromFlow,
    getVariables
) {
    if (action?.libraryLabel.includes('CUSTOM')) {
        return <CustomAction action={action} showAlert={showAlert} variableRender={variableRender} variables={variables}
            setOpenVariable={setOpenVariable} debuggingStart={debuggingStart}
            debuggingExpand={debuggingExpand} automVersionId={automVersionId} automId={automId} setVariables={setVariables}
            automDetail={automDetail} setAutomDetail={setAutomDetail} fromFlow={fromFlow} getVariables={getVariables} />
    }
}

export default Actions;
